import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className, rows = 3, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          'flex w-full rounded-md border border-input bg-surface px-3 py-2 text-sm',
          'placeholder:text-muted-foreground focus-ring',
          'disabled:cursor-not-allowed disabled:opacity-60',
          'transition-[border-color,box-shadow] duration-150 ease-out',
          className,
        )}
        {...rest}
      />
    );
  },
);
